import { useBillsStore } from '@/stores/bills'
import { useEffect, useState } from 'react'
import { SkeletonCard } from './skeleton-card'

export function CardTotal() {
  const [total, setTotal] = useState<number>(0)
  const { payments, isLoading } = useBillsStore()

  useEffect(() => {
    if (payments) {
      let _total = 0
      payments.forEach((item) => {
        _total = Number(item.amount) + _total
      })

      setTotal(_total)
    }
  }, [payments])

  if (!payments || isLoading) return <SkeletonCard />

  return (
    <article className="bg-[#37393F] rounded-lg py-4 px-5 space-y-4">
      <header className="font-semibold flex gap-3 justify-between items-center">
        <h4 className="font-bold capitalize">Total</h4>
        <span>MZN</span>
      </header>
      <div className="text-2xl font-extrabold">
        {new Intl.NumberFormat('pt-MZ', {
          style: 'currency',
          currency: 'MZN',
        })
          .format(total)
          .replace('MTn', '')}
      </div>
    </article>
  )
}
